import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const VISITOR_KEY = "hiresensor-vid";

function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

/** Records a page view on every client-side route change. */
export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    fetch("/api/analytics/pageview", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path,
        referrer: document.referrer || undefined,
        visitor_id: getVisitorId(),
      }),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
